import React from 'react';
import { Link } from 'react-router-dom';
import { Treatment } from '../../types/content';
import { useBrand } from '../../contexts/BrandContext';
export function TreatmentCard({
  treatment
}: {
  treatment: Treatment;
}) {
  const {
    treatmentImage
  } = useBrand();
  return <article className="flex h-full flex-col rounded-brand border border-ink/15 bg-cream-light" data-id="element-342" data-mp="2blofflwjpqh5">
      <Link to={`/treatments/${treatment.slug}`} className="group flex h-full flex-col" data-id="element-343" data-mp="26n4xrxozj0ul">
        <img src={treatmentImage(treatment.slug, treatment.image)} alt="" className="h-44 w-full rounded-t-brand object-cover" loading="lazy" data-id="element-344" data-mp="21ns5gxfch1km" />
        <div className="flex flex-1 flex-col p-6" data-id="element-345" data-mp="1sr9is2xpi9wh">
          <p className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-346" data-mp="1nv2aw4lr2obw">
            {treatment.category}
          </p>
          <h3 className="mt-3 font-serif text-2xl leading-snug text-ink transition-colors duration-150 ease-brand group-hover:text-brick" data-id="element-347" data-mp="1iuoczfdv4url">
            {treatment.name}
          </h3>
          <p className="mt-3 text-[0.9375rem] leading-relaxed text-ink-soft" data-id="element-348" data-mp="sw86n7sgc19k">{treatment.tagline}</p>
          <div className="rule mt-auto flex items-end justify-between gap-4 pt-5" data-id="element-349" data-mp="xp1azuk0d7l4">
            <div data-id="element-350" data-mp="izv55nqo0j49">
              <p className="text-[0.9375rem] text-ink" data-id="element-351" data-mp="j0emp3cel5hr">
                ${treatment.price}
                <span className="text-ink-muted" data-id="element-352" data-mp="nz80kwvlqyig"> {treatment.cadence}</span>
              </p>
              <p className="mt-1 text-sm text-ink-soft" data-id="element-353" data-mp="1bnhfrfyb8o0m">{treatment.status}</p>
            </div>
            <p className="whitespace-nowrap text-sm text-ink-muted" data-id="element-354" data-mp="1gn3yg4wwqwgt">
              {treatment.rxRequired ? 'Prescription' : 'No prescription'}
            </p>
          </div>
        </div>
      </Link>
    </article>;
}